var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(!_vm.isShowGift)?_c('lottery',{on:{"showGift":_vm.showGift}}):_c('gift')],1)}
var staticRenderFns = []

export { render, staticRenderFns }